import {External, M} from "../external";

export const fixedFilters = [
  {
    label: M.FIRST_SEEN,
    icon: "fa-calendar",
    type: External.CRM_PROPERTY_TYPE.DATE,
    fType: External.CRM_FILTER_TYPE.FIRST_SEEN,
    id: 0
  },
  {
    label: M.SIGNED_UP,
    icon: "fa-calendar",
    type: External.CRM_PROPERTY_TYPE.DATE,
    fType: External.CRM_FILTER_TYPE.SIGNED_UP,
    id: 0
  },
  {
    label: M.MEMBER_GROUP,
    icon: "fa-list-ul",
    type: External.CRM_PROPERTY_TYPE.LIST,
    fType: External.CRM_FILTER_TYPE.MEMBER_GROUP,
    id: 0
  } /*, {
     label: 'Last Seen',
     icon: 'fa-calendar',
     type: External.CRM_PROPERTY_TYPE.DATE,
     fType: External.CRM_FILTER_TYPE.LAST_SEEN,
     id: 0
     }*/,
  {
    label: M.TAG,
    icon: "fa-tag",
    fType: External.CRM_FILTER_TYPE.TAG,
    id: 0
  },
  {
    label: M.SUBSCRIBER_LIST,
    icon: "fa-list-ul",
    type: External.CRM_PROPERTY_TYPE.LIST,
    fType: External.CRM_FILTER_TYPE.SUBSCRIBER_LIST,
    id: 0
  }
];

export const ORDER_FILTER_TYPE = {
  NAME: 0,
  EMAIL: 1,
  CREATED: 2,
  TOTAL: 3,
  PRODUCT: 4,
  FUNNEL: 5,
  STATUS: 6,
  PAID: 7,
  UTM_SOURCE: 8,
  UTM_CAMPAIGN: 9,
  UTM_MEDIUM: 10,
  UTM_CONTENT: 11,
  UTM_TERM: 12,
  MEMBER_ID: 13
};

export function getOrderFilters(filterTypes) {
  return filterTypes.map((type) => {
    switch (type) {
      case ORDER_FILTER_TYPE.NAME:
        return {
          label: M.NAME,
          icon: "fa-user-circle",
          type: External.CRM_PROPERTY_TYPE.STRING,
          fType: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
          id: ORDER_FILTER_TYPE.NAME
        };
      case ORDER_FILTER_TYPE.EMAIL:
        return {
          label: M.EMAIL,
          icon: "fa-at",
          type: External.CRM_PROPERTY_TYPE.STRING,
          fType: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
          id: ORDER_FILTER_TYPE.EMAIL
        };
      case ORDER_FILTER_TYPE.CREATED:
        return {
          label: M.CREATED,
          icon: "fa-calendar",
          type: External.CRM_PROPERTY_TYPE.DATE,
          fType: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
          isAlwaysDefined: true,
          id: ORDER_FILTER_TYPE.CREATED
        };
      case ORDER_FILTER_TYPE.TOTAL:
        return {
          label: M.TOTAL,
          icon: "fa-money",
          type: External.CRM_PROPERTY_TYPE.NUMBER,
          fType: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
          isAlwaysDefined: true,
          id: ORDER_FILTER_TYPE.TOTAL
        };
      case ORDER_FILTER_TYPE.PRODUCT:
        return {
          label: M.PRODUCT,
          icon: "fa-list-ul",
          type: External.CRM_PROPERTY_TYPE.LIST,
          fType: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
          isAlwaysDefined: true,
          id: ORDER_FILTER_TYPE.PRODUCT
        };
      case ORDER_FILTER_TYPE.FUNNEL:
        return {
          label: M.FUNNEL,
          icon: "fa-list-ul",
          type: External.CRM_PROPERTY_TYPE.LIST,
          fType: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
          id: ORDER_FILTER_TYPE.FUNNEL
        };
      case ORDER_FILTER_TYPE.STATUS:
        return {
          label: M.STATUS,
          icon: "fa-list-ul",
          type: External.CRM_PROPERTY_TYPE.LIST,
          fType: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
          isAlwaysDefined: true,
          id: ORDER_FILTER_TYPE.STATUS
        };
      case ORDER_FILTER_TYPE.PAID:
        return {
          label: M.PAID,
          icon: "fa-list-ul",
          type: External.CRM_PROPERTY_TYPE.BOOLEAN,
          fType: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
          isAlwaysDefined: true,
          id: ORDER_FILTER_TYPE.PAID
        };
      case ORDER_FILTER_TYPE.UTM_SOURCE:
        return {
          label: M.UTM_SOURCE_LBL,
          icon: "fa-list-ul",
          type: External.CRM_PROPERTY_TYPE.STRING,
          fType: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
          id: ORDER_FILTER_TYPE.UTM_SOURCE
        };
      case ORDER_FILTER_TYPE.UTM_CAMPAIGN:
        return {
          label: M.UTM_CAMPAIGN_LBL,
          icon: "fa-list-ul",
          type: External.CRM_PROPERTY_TYPE.STRING,
          fType: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
          id: ORDER_FILTER_TYPE.UTM_CAMPAIGN
        };
      case ORDER_FILTER_TYPE.UTM_MEDIUM:
        return {
          label: M.UTM_MEDIUM_LBL,
          icon: "fa-list-ul",
          type: External.CRM_PROPERTY_TYPE.STRING,
          fType: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
          id: ORDER_FILTER_TYPE.UTM_MEDIUM
        };
      case ORDER_FILTER_TYPE.UTM_CONTENT:
        return {
          label: M.UTM_CONTENT_LBL,
          icon: "fa-list-ul",
          type: External.CRM_PROPERTY_TYPE.STRING,
          fType: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
          id: ORDER_FILTER_TYPE.UTM_CONTENT
        };
      case ORDER_FILTER_TYPE.UTM_TERM:
        return {
          label: M.UTM_TERM_LBL,
          icon: "fa-list-ul",
          type: External.CRM_PROPERTY_TYPE.STRING,
          fType: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
          id: ORDER_FILTER_TYPE.UTM_TERM
        };
    }
  });
}
